<template>
	<div class="p-0 md:p-10">
		<div class="contained-section w-full bg-gray-100 md:rounded-md md:p-10">
			<h3 class="text-2xl">One last thing...</h3>
			<p class="mb-8 text-gray-700">Information about your company</p>
			<form @submit.prevent="onSubmitCompanyInfo">
				<div class="space-y-4">
					<FormSelectbox
						ref="numberOfStaffDropdownRef"
						key="staff-input"
						v-model="staff"
						name="staff"
						label-name="Number of employees"
						:options="numberOfStaff"
						:error="errors.staff"
					/>
					<FormSelectbox
						ref="fleetSizeDropdownRef"
						key="fleet-input"
						v-model="fleet"
						name="fleet"
						label-name="Size of fleet"
						:options="fleetSize"
						:error="errors.fleet"
					/>
					<div class="flex flex-col gap-4 md:flex-row">
						<InputField
							v-model="city"
							label="City"
							name="city"
							class="w-full"
							:error="errors.city"
						/>
						<StatesSelectbox
							v-model="state"
							name="state"
							label="State"
							class="w-full"
							:error="errors.state"
						/>
					</div>
					<InputField
						v-model="message"
						label="Message (optional)"
						name="message"
						:error="errors.message"
					/>
					<Transition name="alert">
						<AlertBox v-if="hasError">
							<AlertMessages :messages="hasError" />
						</AlertBox>
					</Transition>
					<CarbarButton
						:is-full-width="false"
						:disabled="!meta.valid || isSubmitting"
						:show-loader="isSubmitting"
						class="mt-4"
					>
						<span class="text-white">Submit</span>
					</CarbarButton>
				</div>
			</form>
		</div>
	</div>
</template>

<script setup>
import { useForm, useField } from 'vee-validate'
import * as yup from 'yup'
import CarbarButton from '@/components/buttons/CarbarButton.vue'
import InputField from '@/components/inputs/InputField.vue'
import { useBusinessRegister } from '@/stores/business-register-your-interest'
import AlertBox from '@/components/alerts/AlertBox.vue'
import AlertMessages from '@/components/alerts/AlertMessages.vue'
import FormSelectbox from '@/components/selectboxes/FormSelectbox.vue'
import StatesSelectbox from '@/components/selectboxes/StatesSelectbox.vue'

const numberOfStaff = [
	{ value: '0-5', label: '0-5' },
	{ value: '6-20', label: '6-20' },
	{ value: '21-100', label: '21-100' },
	{ value: '100+', label: '100+' },
]

const fleetSize = [
	{ value: '0-5', label: '0-5' },
	{ value: '6-20', label: '6-20' },
	{ value: '21-100', label: '21-100' },
	{ value: '100+', label: '100+' },
]

const numberOfStaffDropdownRef = ref(null)
const fleetSizeDropdownRef = ref(null)

const businessRegister = useBusinessRegister()
const hasError = computed(() => businessRegister.hasErrorsEnquireForm)

const { handleSubmit, errors, isSubmitting, meta, resetForm } = useForm({
	validationSchema: yup.object({
		city: yup.string().required('City is required'),
		state: yup.string().required('State is required'),
		staff: yup.string().required('Number of staff is required'),
		fleet: yup.string().required('Fleet size is required'),
		message: yup.string(),
	}),
})

const { value: city } = useField('city')
const { value: state } = useField('state')
const { value: staff } = useField('staff')
const { value: fleet } = useField('fleet')
const { value: message } = useField('message')

const updateFormData = (formData, values) => {
	const updatedFormData = formData

	updatedFormData.number_of_staff = values.staff
	updatedFormData.size_of_fleet = values.fleet
	updatedFormData.address = values.office_address
	updatedFormData.city = values.city
	updatedFormData.state_dropdown_ = values.state
	updatedFormData.message = values.message

	return updatedFormData
}

const onSubmitCompanyInfo = handleSubmit(async (values) => {
	businessRegister.companyInfo = updateFormData(
		businessRegister.companyInfo,
		values
	)

	await businessRegister.submitCompanyInfoForm()

	if (!hasError.value) {
		resetAndClearForm()
	}
})

const resetAndClearForm = () => {
	resetForm()
}
</script>
